import React from 'react'
import ChipOptionField from '../../../../../../common/inputs/chipOptionField/ChipOptionField'
import { FieldProps, YesNoOrByAppointmentString } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const AirConditioningField: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
}) => {
  return (
    <ChipOptionField
      id='air-conditioning'
      propertyName='airConditioning'
      translation='wizard.screen.otherFacilities.'
      labelTranslationKey='wizard.screen.otherFacilities.airConditioning'
      option={insertionData.airConditioning as string}
      options={YesNoOrByAppointmentString}
      onChange={(value) => onChange({ screen: screenName, property: 'airConditioning' }, value)}
    />
  )
}

export default AirConditioningField
